import { createSceneReducer } from 'reducers/reducers-util';
import clientsDataReducer from './clients.data';
import clientsUiReducer from './clients.ui';

export default createSceneReducer(clientsDataReducer, clientsUiReducer);
